/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The component for input and validate money
 *
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.2.0
 */

import { ChangeEvent } from 'react';

import { Input } from '../index';
import { EInputKind, IInputProps } from '../Input/Input';

interface IMoneyInputProps {
    isValid?: boolean;
    onMoneyInputChange: (value: string) => void;
    moneyPlaceholder?: string;
}

export const MoneyInput = (props: IMoneyInputProps & IInputProps) => {
    const { onMoneyInputChange, isValid, moneyPlaceholder, ...inputProps } = props;
    const moneyRegExp = new RegExp(/^([1-9]\d*|0)(?:[.,]\d{0,2})?/);

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value.replace(/\s/g, '');
        const matchedValue = value.match(moneyRegExp);
        if (!value) {
            onMoneyInputChange(value);
        } else if (matchedValue && inputProps.value !== matchedValue[0]) {
            onMoneyInputChange(matchedValue[0]);
        }
    };

    return (
        <Input
            {...inputProps}
            kind={isValid !== undefined && !isValid ? EInputKind.error : undefined}
            placeholder={moneyPlaceholder ? moneyPlaceholder : '0,00'}
            onChange={handleChange}
        />
    )
};
